import { api } from '@packages/backend/convex/_generated/api';
import { useQuery } from 'convex-helpers/react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { linkifyText } from '@/utils/linkifyText';

// In dev the backend builds the link with a `localhost` base URL. When testing on a phone
// (served over Tailscale), rewrite the session link's origin to the host this page is loaded
// from so the link is tappable on that device.
const withCurrentOrigin = (message: string) =>
  import.meta.env.DEV
    ? message.replace(/https?:\/\/[^/\s]+(\/s\/)/g, `${window.location.origin}$1`)
    : message;

export const TestSmsPreview = ({ mobileNumber }: { mobileNumber: string }) => {
  const { data: testSmsMessage } = useQuery(api.sessions.getTestSmsMessage, {
    mobileNumber,
  });

  if (!testSmsMessage) return null;

  return (
    <Card className="mt-6 gap-2" data-testid="test-sms-message">
      <CardHeader>
        <CardTitle className="text-xs uppercase tracking-wide text-muted-foreground">
          SMS Message (Test)
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-xs text-foreground">{linkifyText(withCurrentOrigin(testSmsMessage))}</p>
      </CardContent>
    </Card>
  );
};
